import React, { useMemo, useCallback } from 'react';
import PropTypes from "prop-types";
import CustomerDropDown from '../../../../components/shared/CustomerDropDown';
import { RateAssignment as RateAssignmentApi } from '../../../../api/services/next';
import { useTextResources } from '../../../../language';

const CustomerEditor = ({
    rateId,
    row,
    // eslint-disable-next-line no-unused-vars
    disabled,
    ...props
}) => {
    const text = useTextResources();

	const spec = useMemo(() => ({
		RateId: rateId,
	}), [rateId]);

    const sort = useCallback((result) => result.customers, []);

    const dataOrApiProps = useMemo(() => {
        if (row.Id > 0) {
            return {
                data: [{
                    Id: row.EntityId,
                    Name: row.CustomerName,
                }],
            };
        } else {
            return {
                api: RateAssignmentApi.GetAddRateAssignmentsOptions,
                spec,
                sort,
            };
        }
    }, [row, sort, spec]);
	
	return (
		<CustomerDropDown
			{...dataOrApiProps}
            disabled={row.Id > 0}
            required
            placeholder={text('Customer')}
            basic
            className="customer-drop-down"
			{...props}
		/>
	);
};

CustomerEditor.propTypes = {
    rateId: PropTypes.number.isRequired,
    row: PropTypes.shape({
        Id: PropTypes.number.isRequired,
        EntityId: PropTypes.number,
        CustomerName: PropTypes.string,
    }),
    disabled: PropTypes.bool,
}

CustomerEditor.defualtProps = {
    rows: [],
}

export default CustomerEditor;